/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const loopFinancialsSchema = z.object({
  budgetAmount: z.string().describe('Budget amount for this loop').nullish(),
  loopId: z.int().describe('Loop id'),
  updatedAt: z.iso.datetime().describe('When these financial values were last updated'),
  updatedBy: z.string().describe('User who last updated these financial values'),
});
